var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _g, _g2, _g3, _g4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMagneticTemplate = function SvgMagneticTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144.0mm",
    height: "226.0mm",
    viewBox: "-5.199999999999999 -12.0 144.0 226.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 116.8,
    y1: 10,
    y2: 10,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 116.8,
    x2: 116.8,
    y1: 10,
    y2: 50,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 116.8,
    y1: 50,
    y2: 50,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 16.8,
    y1: 10,
    y2: 50,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 16.8,
    y1: 50,
    y2: 150,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 116.8,
    y1: 150,
    y2: 150,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 116.8,
    x2: 116.8,
    y1: 50,
    y2: 150,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 116.8,
    y1: 155,
    y2: 155,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 116.8,
    x2: 116.8,
    y1: 155,
    y2: 192,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 116.8,
    y1: 192,
    y2: 192,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    x2: 16.8,
    y1: 155,
    y2: 192,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 26.8,
    x2: -0.1999999999999993,
    y1: -7,
    y2: 20,
    stroke: "black",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 26.8,
    x2: 106.8,
    y1: -7,
    y2: -7,
    stroke: "black",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 106.8,
    x2: 133.8,
    y1: -7,
    y2: 20,
    stroke: "black",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 133.8,
    x2: 133.8,
    y1: 20,
    y2: 182,
    stroke: "black",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 106.8,
    x2: 133.8,
    y1: 209,
    y2: 182,
    stroke: "black",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 26.8,
    x2: 106.8,
    y1: 209,
    y2: 209,
    stroke: "black",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: -0.1999999999999993,
    x2: 26.8,
    y1: 182,
    y2: 209,
    stroke: "black",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: -0.1999999999999993,
    x2: -0.1999999999999993,
    y1: 20,
    y2: 182,
    stroke: "black",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9,
    x2: 113.6,
    y1: 12.5,
    y2: 12.5,
    stroke: "gray",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 113.6,
    x2: 113.6,
    y1: 12.5,
    y2: 178.8,
    stroke: "gray",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9,
    x2: 113.6,
    y1: 178.8,
    y2: 178.8,
    stroke: "gray",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9,
    x2: 19.9,
    y1: 12.5,
    y2: 178.8,
    stroke: "gray",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16.799999,
    x2: 116.8,
    y1: 5,
    y2: 5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.8,
    x2: 112.8,
    y1: 5,
    y2: 4,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.8,
    x2: 112.8,
    y1: 5,
    y2: 6,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.799999,
    x2: 20.799999,
    y1: 5,
    y2: 4,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.799999,
    x2: 20.799999,
    y1: 5,
    y2: 6,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 71.800003,
    y: 3,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 21.799999,
    y1: 50,
    y2: 150,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 20.799999,
    y1: 50,
    y2: 54,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 22.799999,
    y1: 50,
    y2: 54,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 20.799999,
    y1: 150,
    y2: 146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 22.799999,
    y1: 150,
    y2: 146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 26.799999,
    y: 102,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90,26.800001,102)"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 21.799999,
    y1: 10,
    y2: 50,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 20.799999,
    y1: 10,
    y2: 14,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 22.799999,
    y1: 10,
    y2: 14,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 20.799999,
    y1: 50,
    y2: 46,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.799999,
    x2: 22.799999,
    y1: 50,
    y2: 46,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 26.799999,
    y: 32,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90,26.800001,32)"
  }, "\n            Height\n        "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagneticTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnetic-template.f58ae0cd.svg";
export { ForwardRef as ReactComponent };